import React, { Component } from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

import { Scope } from 'informed';
import { Cell, Grid } from 'react-md';
import { get } from 'lodash-es';

import DateField from './DatePickerField';
import NumericField from './NumericField';
import PercentField from './PercentField';
import ReactSelect from './ReactSelect';
import Select from './Select';
import SwitchFieldMU from './SwitchFieldMU';
import TextField from './TextField';

class ExtraFieldsComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedValue: '',
    };
  }

  render() {
    const { ...props } = this.props;
    // eslint-disable-next-line no-unused-vars
    const { data, values, type, onSave, strings, classes, readOnly, i18n } = props;
    const { selectedValue } = this.state;
    const renderExtraField = model => {
      const {
        name,
        code,
        placeholder,
        selection,
        // sorted,
        // business_kind,
        technical_kind: technicalKind,
        required = true,
        sub_data: subData,
        isClearable = true,
        isSearchable = true,
        tooltip,
      } = model;
      const _tooltip = tooltip;
      const extraField = [];

      const defaultValue = get(model, 'default', undefined);
      const initialValue = get(values, code, defaultValue);

      switch (technicalKind) {
        case 'selection': {
          if (Array.isArray(selection) && selection.length < 5) {
            const options = Array.isArray(selection)
              ? selection.map(option => ({ text: option[1], value: option[0] }))
              : [];

            extraField.push(
              <Select
                className="extra field select"
                key={code}
                field={code}
                id={`select-${code}`}
                name={code}
                shrink
                label={name}
                options={options}
                onChange={value => this.setState({ selectedValue: value })}
                value={selectedValue || initialValue}
                initialValue={initialValue}
                disabled={readOnly}
                required={!!required}
                tooltip={_tooltip}
              />
            );
          } else {
            const options = Array.isArray(selection)
              ? selection.map(option => ({ label: option[1], value: option[0] }))
              : [];

            extraField.push(
              <ReactSelect
                className="extra field react select"
                key={code}
                field={code}
                id={`select-${code}`}
                name={name}
                label={name}
                placeholder={placeholder}
                required
                onChange={value => this.setState({ selectedValue: value })}
                value={selectedValue || initialValue}
                initialValue={initialValue}
                options={Array.isArray(options) ? options : []}
                style={{
                  minWith: '200px',
                }}
                disabled={readOnly}
                isClearable={isClearable}
                tooltip={_tooltip}
                isSearchable={isSearchable}
                isDisabled={readOnly}
              />
            );
          }
          break;
        }
        case 'numeric':
        case 'integer':
        case 'float': {
          extraField.push(
            <NumericField
              className="extra field number"
              // type="number"
              key={code}
              field={code}
              id={`numberfield-${code}`}
              name={code}
              shrink
              label={name}
              placeholder={placeholder}
              required={!!required}
              onChange={value => this.setState({ selectedValue: value })}
              value={selectedValue || initialValue}
              initialValue={initialValue}
              disabled={readOnly}
              tooltip={_tooltip}
              lang={i18n.lang}
              technicalKind={technicalKind}
            />
          );
          break;
        }
        case 'boolean': {
          extraField.push(
            <SwitchFieldMU
              className="extra field boolean"
              key={code}
              field={code}
              id={`booleanfield-${code}`}
              name={code}
              shrink
              label={name}
              placeholder={placeholder}
              required={!!required}
              onChange={value => this.setState({ selectedValue: value })}
              value={!!initialValue}
              initialValue={!!initialValue}
              disabled={readOnly}
              tooltip={_tooltip}
            />
          );
          break;
        }
        case 'percent': {
          extraField.push(
            <PercentField
              className="extra field percent"
              key={code}
              field={code}
              id={`percentfield-${code}`}
              name={code}
              shrink
              label={name}
              placeholder={placeholder}
              required={!!required}
              onChange={value => this.setState({ selectedValue: value })}
              value={selectedValue || initialValue}
              initialValue={initialValue}
              disabled={readOnly}
              tooltip={_tooltip}
            />
          );
          break;
        }
        case 'date': {
          extraField.push(
            <DateField
              className="extra field date"
              key={code}
              field={code}
              id={`datefield-${code}`}
              name={code}
              shrink
              label={name}
              placeholder={placeholder}
              required={!!required}
              onChange={value => this.setState({ selectedValue: value })}
              value={selectedValue || initialValue}
              initialValue={initialValue}
              disabled={readOnly}
              tooltip={_tooltip}
            />
          );
          break;
        }
        default: {
          extraField.push(
            <TextField
              className="extra field text"
              key={code}
              field={code}
              id={`textfield-${code}`}
              name={code}
              shrink
              label={name}
              placeholder={placeholder}
              required={!!required}
              onChange={value => this.setState({ selectedValue: value })}
              value={selectedValue || initialValue}
              initialValue={initialValue}
              disabled={readOnly}
              tooltip={_tooltip}
            />
          );
          break;
        }
      }
      let subExtraField = [];
      if (Array.isArray(subData) && subData.length > 0) {
        subExtraField = subData.map(sub => {
          const subExtraFieldDesc = values && [code] && sub[1] === values[code] ? sub[2] : undefined;
          try {
            if (subExtraFieldDesc) return <div className="sub extra field">{renderExtraField(subExtraFieldDesc)}</div>;
          } catch (error) {
            return undefined;
          }
          return undefined;
        });
        extraField.push(subExtraField);
      }
      return extraField;
    };
    const calculateCellSize = model => {
      const nameLength = get(model, 'name', '').length;
      const size = nameLength >= 80 ? 12 : 5;
      return { size };
    };
    const isHidden = model => get(model, 'code', '').includes('__hidden');
    if (Array.isArray(data) && data.length > 0) {
      return (
        <Grid className="grid extra field" style={{ width: '100%' }}>
          {/* tips: to create array in scope => scope= {`extra[${index}]` */}
          <Scope scope="extra">
            {data.map(model => (
              <div
                key={model.code}
                className={cn(Cell.getClassName(calculateCellSize(model)), 'div', 'extra', 'field', {
                  hidden: isHidden(model),
                })}
              >
                {renderExtraField(model)}
              </div>
            ))}
          </Scope>
        </Grid>
      );
    }
    return '';
  }
}

ExtraFieldsComponent.propTypes = {
  formApi: PropTypes.any.isRequired, // eslint-disable-line
  data: PropTypes.array.isRequired, // eslint-disable-line
  type: PropTypes.string, // eslint-disable-line
  onSave: PropTypes.func.isRequired, // eslint-disable-line
  strings: PropTypes.object.isRequired, // eslint-disable-line
  classes: PropTypes.any.isRequired, // eslint-disable-line
  values: PropTypes.any.isRequired, // eslint-disable-line
  readOnly: PropTypes.bool,
  i18n: PropTypes.shape({
    lang: PropTypes.string,
  }),
  tooltip: PropTypes.string,
};

ExtraFieldsComponent.defaultProps = {
  readOnly: false,
  i18n: { lang: 'fr' },
};

export default ExtraFieldsComponent;
